var React = require('react');

function CalendarInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        font-size: 16px;\n        fill: #54b4a4;\n        font-family: FontAwesome5Free-Solid, \"Font Awesome 5 Free\";\n      }\n    ")),React.createElement("text",{"id":"_","data-name":"","className":"cls-1","x":"0.373","y":"14.669","key":1},"")]);
}

CalendarInline.defaultProps = {"width":"15","height":"18","viewBox":"0 0 15 18"};

module.exports = CalendarInline;

CalendarInline.default = CalendarInline;
